<template>
  <a-modal
    ref="model"
    centered
    title="会员密码修改"
    v-model="visible"
    width="450px"
    okText="确认"
    :footer="null"
    @cancel="onCancel"
    :maskClosable="false"
    :destroyOnClose="true"
    :bodyStyle="{ paddingTop: 0 }"
  >
    <div class="content">
      <dataForm
        :colnum="1"
        :content="baseContent"
        ref="baseForm"
        :showButton="false"
      >
      </dataForm>
    </div>
    <div class="form-action">
      <a-button type="primary" @click="onSubmit" :loading="confirmLoading"
        >确认</a-button
      >
      <a-button @click="onCancel">取消</a-button>
    </div>
  </a-modal>
</template>
<script>
import { cache } from "@/utils/common.js";
// import clone from "lodash/clone";
import dataForm from "@/components/dataForm/DataForm";
import moment from "moment";
import md5 from "js-md5";
moment.locale("zh-cn");
export default {
  name: "MemberCharge",
  components: {
    dataForm
  },
  data() {
    return {
      id: 0,
      confirmLoading: false,
      visible: false,
      baseContent: []
    };
  },
  created() {
    this.user = cache.get("user");
    var url = {
      MemberUpdatePassword: "MemberUpdatePassword"
    };
    if (this.user.IsGroupSystem) {
      for (let i in url) {
        url[i] = "Group" + url[i];
      }
    }
    this.url = url;
  },
  mounted() {},
  methods: {
    init() {
      //基本信息
      this.baseContent = [
        {
          label: "旧密码",
          type: "password",
          name: "OldPassword",
          min: 0,
          props: {
            message: "请输入旧密码"
          }
        },
        {
          label: "新密码",
          type: "password",
          name: "NewPassword",
          min: 0,
          props: {
            message: "请输入新密码"
          }
        }
      ];
    },
    dataInit() {},
    show(id = 0) {
      this.id = id;
      this.init();
      this.visible = true;
    },
    onSubmit() {
      let formData = this.$refs.baseForm.getData();
      if (formData.OldPassword.trim() != "") {
        formData.OldPassword = md5(formData.OldPassword.trim());
      }
      // if (formData.NewPassword.trim() != "") {
      // formData.NewPassword = md5(formData.NewPassword.trim());
      // }
      formData.NewPassword = formData.NewPassword.trim();
      let params = {
        MemberCardId: this.id,
        IsReset: false,
        ...formData
      };
      this.confirmLoading = true;
      this.$post(this.url.MemberUpdatePassword, params)
        .then(res => {
          if (res.Data) {
            this.$message.success("修改成功");
            this.visible = false;
            this.$emit("submit");
          } else {
            this.$message.error(res.Info);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.form-action {
  text-align: center;
  .ant-btn {
    margin-right: 10px;
  }
}

/deep/.ant-modal-body {
  padding: 0;
}
</style>
